import { japanMakers, specialModels, vehiclesWithCountry } from 'config/cars';
import { CarModel } from 'models/StockModel';

export const isJapanCar = (car: CarModel) => japanMakers.includes(car.make.toUpperCase());

export const formatVehicleTypeForPriceTable = (car: CarModel) => {
    if (!car.vehicleType) return '';

    let vehicle = car.vehicleType.replace(' ', '_');

    const model = car.model.toUpperCase() as keyof typeof specialModels;
    if (model in specialModels)
        vehicle = specialModels[model]

    if (vehiclesWithCountry.includes(vehicle))
        vehicle += '_' + (isJapanCar(car) ? 'jp' : 'eu');

    return vehicle;
}

export const financialVehicleType = (car: CarModel) => {
    const model = car.model.toUpperCase() as keyof typeof specialModels;
    if (model in specialModels)
        return `(${specialModels[model]})`;

    return '';
}
